import tw from 'twin.macro'
import React from 'react'
import { orderBy } from 'lodash'
import { ScrollArea } from 'common/components/ScrollArea/ScrollArea'
import { getReadableTime, getTimeDurationString } from 'common/utils/timeDuration'

export function LowConfidenceDurationWktList({ reviewedLowConfWkts, setReviewedLowConfWkts, lowConfidenceWkts }) {
  const orderedLowConfWkts = orderBy(
    Object.entries(lowConfidenceWkts),
    [([, wkt]) => wkt.weekNum, ([, wkt]) => wkt.dayNum, ([, wkt]) => wkt.multiWktIdx ?? 0],
    ['asc', 'asc', 'asc']
  )

  const allWktsReviewed = Object.values(reviewedLowConfWkts).every((isReviewed) => isReviewed)
  return (
    <>
      {orderedLowConfWkts.length > 0 && (
        <>
          <div className='flex items-center mb-1 justify-between'>
            <h3 className='font-semibold'>Workouts</h3>
            <div className='flex items-center mr-3.5'>
              <label htmlFor='confirmAll' className='cursor-pointer text-black mr-2 first-letter:uppercase text-sm'>
                Confirm all
              </label>
              <input
                name='confirmAll'
                id='confirmAll'
                type='checkbox'
                value={allWktsReviewed ? 'on' : 'off'}
                className='cursor-pointer rounded-sm border-black border-opacity-20 text-tGreen focus:ring-0'
                checked={allWktsReviewed ? true : false}
                onChange={() => {
                  let wktsReviewed = {}
                  if (allWktsReviewed) {
                    Object.keys(reviewedLowConfWkts).forEach((wktId) => {
                      wktsReviewed[wktId] = false
                    })
                  } else {
                    Object.keys(reviewedLowConfWkts).forEach((wktId) => {
                      wktsReviewed[wktId] = true
                    })
                  }
                  setReviewedLowConfWkts(wktsReviewed)
                }}
              />
            </div>
          </div>
          <div className='mb-6 rounded-lg overflow-hidden border-gray-200 border-opacity-75 border-2'>
            <ScrollArea css={tw`max-h-52 py-2 px-3`}>
              {orderedLowConfWkts.map(([wktId, info], index) => (
                <div key={wktId} className='flex mb-3 last:mb-0'>
                  <div className='only:w-full w-3/5 only:pr-0 pr-3'>
                    <div className='flex items-start justify-between'>
                      <h4 className='font-semibold capitalize'>
                        {`${index + 1}. `}
                        {info?.wktTitle}
                      </h4>
                      <input
                        name={`confirm-${wktId}`}
                        id={`confirm-${wktId}`}
                        type='checkbox'
                        value={reviewedLowConfWkts?.[wktId] ? 'on' : 'off'}
                        className='cursor-pointer rounded-sm border-black border-opacity-20 text-tGreen focus:ring-0 relative z-50 ml-2'
                        checked={reviewedLowConfWkts?.[wktId] ? true : false}
                        onChange={() =>
                          setReviewedLowConfWkts((state) => ({ ...state, [wktId]: !reviewedLowConfWkts?.[wktId] }))
                        }
                      />
                    </div>
                    <p className='text-gray-500 text-sm'>{`Week ${info?.weekNum}, Day ${info?.dayNum}${info?.multiWktIdx >= 0 ? `, Workout ${info?.multiWktIdx + 1}` : ''} | Est. Duration: ~${getReadableTime(getTimeDurationString((info?.totalSeconds || 60) * 1000))}`}</p>
                    <p className='text-gray-500 text-xs'>{info?.lowConfidenceReason}</p>
                  </div>
                </div>
              ))}
            </ScrollArea>
          </div>
        </>
      )}
    </>
  )
}
